module.exports = __webpack_public_path__ + "static/media/gym-group-lesson.7a54be02.jpg";